
import { defineComponent } from 'vue'

import BaseSvgIcon from '@/components/BaseSvgIcon.vue'

export default defineComponent({
  components: { BaseSvgIcon },
  props: {
    path: {
      type: String,
      'default': () => (''),
    },
    text: {
      type: String,
      'default': () => (''),
    },
  },
})
